import React, { useState } from 'react'
import { GoogleMap, useJsApiLoader, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import { getLoactionHash } from '../..//services/pages';
import { googleMapsProps } from '../../constants';

const containerStyle = {
    width: '100%',
    height: '400px'
};

export const Map = (props: { field: { name: string, value: { coordinates: Address }, id: string, label: string, required: boolean, extra: string }, onChange: (id: string, value: any) => void }) => {
    const { isLoaded } = useJsApiLoader(googleMapsProps as any)

    const [searchBox, setSearchBox] = useState<any>()

    const position = props.field.value?.coordinates ? {
        lat: props.field.value?.coordinates?.latitude,
        lng: props.field.value?.coordinates?.longitude
    } : null

    const center = {
        lat: 37.0902,
        lng: -95.7129
    }

    const onAutoCompletePlaceIsChanged = async () => {
        if (searchBox?.getPlaces?.()?.length) {
            const place = searchBox.getPlaces()[0]
            console.log(place.geometry.location.lng)
            const r = await getLoactionHash({
                "address": place.formatted_address,
                "latitude": place.geometry.location.lat?.(),
                "longitude": place.geometry.location.lng?.()
            })
            if (r.success)
                props.onChange(props.field.id, r.data);
        }
    };

    let extra: any = {}
    try {
        extra = JSON.parse(props.field.extra)
    } catch (ex) { }

    return isLoaded ? (
        <>
            <StandaloneSearchBox
                onLoad={ref => setSearchBox(ref)}
                onPlacesChanged={onAutoCompletePlaceIsChanged}
            >
                <div className="formrow">
                    <div className="formcol">
                        <label className="font-weight-bold text-muted"><u>{props.field.label}{props.field.required ? '*' : ''}</u></label>
                        <small className="form-text text-muted pb-3">{extra && extra.help}</small>
                        <input
                            name={props.field.name}
                            type="text"
                            placeholder="Location"
                            defaultValue={props.field.value?.coordinates?.address || ''}
                        />
                    </div>
                </div>
            </StandaloneSearchBox>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={position || center}
                zoom={position ? 13 : 3.5}
                options={{
                    streetViewControl: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }}
            >
                {position && <Marker position={position} />}
            </GoogleMap>
        </>
    ) : <></>
}

export default React.memo(Map)


// WEBPACK FOOTER //
// ./src/client/pages/Map.tsx